"use strict";

import "./Bubble.css";

import InfoBox from "./../InfoBox";

/** @class: Bubble
	
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {HTMLElement} params.content
		@param {Number} [params.verticalOffset=2]
		@param {Number} [params.zIndex]
*/

const DEFAULT_BG_COLOR = "white";
const DEFAULT_TEXT_COLOR = "#444";
const DEFAULT_VERTICAL_OFFSET = 2;

export default class Bubble extends InfoBox {
	
	constructor(params) {
		
		params = params || {};
		
		if (!params.map || !params.position || !params.content) throw new Error("Missing parameter...");
		
		const wrapper = document.createElement("div");
		wrapper.className = "Bubble";
		
		super({
			content: wrapper,
			position: params.position,
			alignBottom: true,
			visible: false,
			closeBoxURL: "",
			zIndex: params.zIndex || null,
			maxWidth: params.maxWidth || null
		});
		
		this.map = params.map;
		this.wrapper = wrapper;
		this.verticalOffset = params.verticalOffset || DEFAULT_VERTICAL_OFFSET;
		
		this.createBody(params.content);
		this.createTriangleContainer();
		this.setColor();
		
		google.maps.event.addListener(this, 'domready', this.updatePixelOffset);
		
		this.open(this.map);
	}
	
	updatePixelOffset() {
		this.setOptions({
			pixelOffset: new google.maps.Size(-(this.wrapper.getBoundingClientRect().width/2), this.verticalOffset),
			visible: true
		});
	}
	
	refresh() {
		this.open(this.map);
	}
	
	createBody(content) {
		this.body = document.createElement("div");
		this.wrapper.appendChild(this.body);
		this.body.className = "Body";
		this.body.appendChild(content);
	}
	
	createTriangleContainer() {
		this.triangleContainer = document.createElement("div");
		this.wrapper.appendChild(this.triangleContainer);
		this.triangleContainer.className = "TriangleContainer";
		
		this.triangleMask = document.createElement("div");
		this.triangleContainer.appendChild(this.triangleMask);
		
		this.triangle = document.createElement("div");
		this.triangleContainer.appendChild(this.triangle);
	}
	
	setColor(backgroundColor, textColor) {
		backgroundColor = backgroundColor || DEFAULT_BG_COLOR;
		textColor = textColor || DEFAULT_TEXT_COLOR;
		this.body.style.backgroundColor = backgroundColor;
		this.body.style.color = textColor;
		this.triangle.style.borderColor = `${backgroundColor} transparent transparent transparent`;
	}
}


// WEBPACK FOOTER //
// ./src/view/Map/Bubble/Bubble.js